import React from 'react';

import { CreditCardIcon } from '@heroicons/react/24/outline';

import bancontactIcon from 'assets/bancontact-icon.svg';
import epsIcon from 'assets/eps-icon.svg';
import idealIcon from 'assets/ideal-icon.svg';
import { formatPrice } from 'utils/prices';
import { IPrice } from 'utils/types';
import { cn } from 'utils/utils';

const PAYMENT_METHOD_ICONS: Record<string, React.ReactNode> = {
  ideal: <img src={idealIcon} alt='ideal' className='w-10 h-10' />,
  bancontact: <img src={bancontactIcon} alt='bancontact' className='w-10 h-10' />,
  eps: <img src={epsIcon} alt='eps' className='w-10 h-10' />,
  creditcard: <CreditCardIcon className='w-10 h-10' />,
};

interface IPaymentMethodCardProps {
  method: string;
  label: string;
  appliedFee: IPrice;
  selected: boolean;
  handleSelect: () => void;
}

const PaymentMethodCard: React.FC<IPaymentMethodCardProps> = ({
  method,
  label,
  appliedFee,
  selected,
  handleSelect,
}) => (
  <div
    onClick={handleSelect}
    className={cn(
      'flex gap-6 justify-between items-center rounded-md border px-4 py-6 shadow-sm cursor-pointer hover:shadow-md transition-shadow',
      selected && 'outline-2 outline-primary'
    )}
  >
    <div className='flex gap-4 items-center'>
      <span>
        {PAYMENT_METHOD_ICONS[method] ?? (
          <div className='w-10 h-10 flex items-center justify-center bg-gray-200 rounded-full text-gray-600'>
            {method.charAt(0)}
          </div>
        )}
      </span>
      <div>
        <p className='font-[MuseoSansCyrl700]'>{label}</p>
        <p className='min-[380px]:hidden font-[MuseoSansCyrl] text-sm text-gray-500'>
          Fee applied: {formatPrice(appliedFee)}
        </p>
      </div>
    </div>
    <p className='max-[380px]:hidden font-[MuseoSansCyrl] text-sm text-gray-500'>
      Fee applied: {formatPrice(appliedFee)}
    </p>
  </div>
);

export default PaymentMethodCard;
